import React from "react"
import logoImg from "../assets/images/logoWhite.png"
import logoImgSm from "../assets/images/logoSquareWhite.png"
import { useNavigate } from "react-router-dom"
import { useAuth } from '../context/authContext'

const Sidebar = () => {
    const navigate = useNavigate()
    const { logout } = useAuth()

    return (
        <div className="leftside-menu">
            <a href="index.html" className="logo logo-light">
                <span className="logo-lg">
                    <img src={logoImg} alt="logo" />
                </span>
                <span className="logo-sm">
                    <img src={logoImgSm} alt="small logo" />
                </span>
            </a>

            <a href="index.html" className="logo logo-dark">
                <span className="logo-lg">
                    <img src={logoImg} alt="dark logo" />
                </span>
                <span className="logo-sm">
                    <img src={logoImgSm} alt="small logo" />
                </span>
            </a>

            <div className="h-100" id="leftside-menu-container" data-simplebar>
                <ul className="side-nav">

                    <li className="side-nav-title">Main</li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/dashboard")}}
                            className="side-nav-link toggle">
                            <i className="ri-dashboard-3-line"></i>
                            <span> Dashboard </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/chatbot-leads")}}
                            className="side-nav-link toggle">
                            <i className="ri-user-2-line"></i>
                            <span> Chatbot Leads </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/contact-leads")}}
                            className="side-nav-link toggle">
                            <i className="ri-user-3-line"></i>
                            <span> Contact Leads </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/mortgage-leads")}}
                            className="side-nav-link toggle">
                            <i className="ri-bank-line"></i>
                            <span> Mortgage Leads </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {navigate("/newsletter-leads")}}
                            className="side-nav-link toggle">
                            <i className="ri-user-4-line"></i>
                            <span> Newsletter Leads </span>
                        </div>
                    </li>
                    <li className="side-nav-item">
                        <div onClick={() => {logout();navigate('/login')}}
                            className="side-nav-link toggle">
                            <i className="ri-logout-box-line"></i>
                            <span> Logout </span>
                        </div>
                    </li>
                </ul>

                <div className="clearfix"></div>
            </div>
        </div>
    )
}

export default Sidebar